import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class MyDocuments extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'userdocument',
            data: null,
            loading: true,
            files: [],
            isChild: this.isNull(props.IsChild) ? false : props.IsChild
        };
    }
    componentDidMount() {
        this.referechMe();
    }
    referechMe() {
        this.refreshData(null, "my");
    }
    setProfilePic(_file, typeId) {
        this.getBase64(_file).then(file => {
            var index = -1;
            for (var i = 0; i < this.state.files.length; i++) {
                if (this.state.files[i].typeId == typeId) index = i;
            }
            if (index == -1) {
                this.state.files.push({
                    pic: file,
                    picFileName: _file.name,
                    typeId: typeId
                });
            }
            else {
                this.state.files[index].pic = file;
                this.state.files[index].picFileName = _file.name;
            }
        });
    }
    save(id, documentTypeId) {
        var index = -1;
        for (var i = 0; i < this.state.files.length; i++) {
            if (this.state.files[i].typeId == documentTypeId) index = i;
        }
        if (index == -1) {
            this.showErorrMessage("لطفا فایلی انتخاب نمایید");
            return;
        }

        this.httpPost("api/v1/userdocument/save", {
            id: id,
            documentTypeId: documentTypeId,
            pic: this.state.files[index].pic,
            picFileName: this.state.files[index].picFileName,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.referechMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner p-0">
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text text-center">نوع مدرک</span></div>
                                        <div className="nk-tb-col"><span className="sub-text text-center">وضعیت</span></div>
                                        <div className="nk-tb-col"><span className="sub-text text-center">آخرین بروزرسانی</span></div>
                                        <div className="nk-tb-col"><span className="sub-text text-center">فایل</span></div>
                                        <div className="nk-tb-col"><span className="sub-text">عملیات</span></div>
                                    </div>
                                    {this.state.data.records.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.documentTypeTitle}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.documentStatusString}{record.documentStatus === 3 ? " " + record.discardNote : ""}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.editDate}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.isBlank(record.contentPath) ? "ارسال نشده" : <a href={record.contentPath} target="_blank">مشاهده فایل</a>}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <div className="flex flex-row">
                                                    {(record.documentStatus === 0 || record.documentStatus === 3) && <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0], record.documentTypeId) }} />}
                                                    {record.documentStatus === 0 && <a onClick={e => this.save(this.getDefaultGuid(), record.documentTypeId)} className="hand btn btn-success btn-sm">ارسال فایل</a>}
                                                    {record.documentStatus === 3 && <a onClick={e => this.save(record.id, record.documentTypeId)} className="hand btn btn-primary btn-sm">بروز رسانی</a>}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                !this.state.isChild && <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                !this.state.isChild && <Footer />
            ];

        return contents;
    }
}